import { HomeState } from "./reducer"
import { createSelector } from "reselect"

export const getHome = (state: { home: HomeState }) => state.home
export const getTitle = createSelector(getHome, (homepageContent) => homepageContent.title)
export const getRepositories = createSelector(
  getHome,
  (homepageContent) => homepageContent.repositories
)
export const getTools = createSelector(getHome, (homepageContent) => homepageContent.tools)
export const getReferenceLinks = createSelector(
  getHome,
  (homepageContent) => homepageContent.referenceLinks
)
export const getSearchKeyWords = createSelector(
  getHome,
  (homepageContent) => homepageContent.searchKeyWords
)
